/* viu-chat-dock.js — 2026-09-18
 * Shopify Inbox 的 <shopify-chat> 是 body 直屬 fixed 元素（bottom:0,
 * z-index:2147483000），會蓋住 .tabbar（z-index:95）。
 *
 * 這支只做兩件事，樣式全部在 viu.css 第 7 段：
 *   1. 判定聊天是「收合(按鈕)」還是「展開(對話視窗)」→ body.chat-docked
 *      展開時必須把位移撤掉，否則手機版全螢幕對話框會整個錯位。
 *   2. 收合狀態下，下滑收起、上滑出現 → body.chat-hidden
 *
 * 斷點 999px：tabbar 在 ≥1000px 才隱藏。
 */
(function () {
  if (!window.matchMedia('(max-width: 999px)').matches) return;

  var el = null, last = 0, ticking = false;

  function measure() {
    if (!el) return;
    // 收合時是小按鈕（約 60-90px）；展開時是對話視窗，一定遠高於 200px
    var open = el.getBoundingClientRect().height > 200;
    document.body.classList.toggle('chat-docked', !open);
    if (open) document.body.classList.remove('chat-hidden');
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      if (!document.body.classList.contains('chat-docked')) return;
      var y = window.scrollY;
      if (y > last + 8 && y > 120) document.body.classList.add('chat-hidden');
      else if (y < last - 8) document.body.classList.remove('chat-hidden');
      last = y;
    });
  }

  function bind(node) {
    el = node;
    measure();
    if (window.ResizeObserver) new ResizeObserver(measure).observe(el);
    // 點擊當下先解除位移，避免展開動畫期間被推上去
    el.addEventListener('click', function () {
      document.body.classList.remove('chat-docked', 'chat-hidden');
      setTimeout(measure, 800);
    }, true);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  var found = document.querySelector('shopify-chat');
  if (found) { bind(found); return; }

  // app script 是非同步注入的，等它出現
  var mo = new MutationObserver(function () {
    var n = document.querySelector('shopify-chat');
    if (n) { mo.disconnect(); bind(n); }
  });
  mo.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 15000);
})();
